import { GlobalUserDataContext } from '@/contexts/GlobalUserDataContext';
import { getBetSummaryReportState } from '@/modules/report/selector';
import { betFailSummarySliceActions } from '@/modules/report/slice/betFailSummary';
import { betRecordSliceActions } from '@/modules/report/slice/betRecord';
import { betSummarySliceActions } from '@/modules/report/slice/betSummary';
import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import { Moment } from 'moment/moment';
import {
    Dispatch,
    SetStateAction,
    useContext,
    useEffect,
    useRef,
    useState,
} from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { DialogContext } from '..';
import { AudioPlayContext } from '../../../contexts/AudioPlayContext';
import { WebSocketContext } from '../../../contexts/WebSocketContext';
import {
    CMDPsBetLogFailSummaryQuery,
    CMDPsBetLogSummaryQuery,
} from '../../../models/cmd/live';
import { DateRangePicker } from '../../report/components/DateRangePicker';
import { BetRecordReport } from './betRecord/BetRecordReport';
import { BetRecordTabPage, BetRecordTabs } from './BetRecordTabs';

type Props = {
    setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export const BetRecord = (props: Props) => {
    const { setIsOpen } = props;

    const dispatch = useDispatch();
    const [start, setStart] = useState<Moment>();
    const [end, setEnd] = useState<Moment>();
    const [expanded, setExpanded] = useState<boolean>(false);
    const [isRequest, setIsRequest] = useState<boolean>(false);
    const { summaries } = useSelector(getBetSummaryReportState);
    const timerRef = useRef<NodeJS.Timeout>();
    const [startDate, setStartDate] = useState<string>('');
    const [endDate, setEndDate] = useState<string>('');
    const { isAutoConfirmEnabled } = useContext(GlobalUserDataContext);

    const { playButtonAudio } = useContext(AudioPlayContext);
    const { sendCommand } = useContext(WebSocketContext);
    const { setExtraCloseHandler } = useContext(DialogContext);

    const handleSubmit = async (_startDate: Moment, _endDate: Moment) => {
        if (_startDate && _endDate) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            setIsRequest(true);

            setStartDate(_startDate.locale('en').format('YYYY-MM-DD'));
            setEndDate(_endDate.locale('en').format('YYYY-MM-DD'));

            const request = new CMDPsBetLogSummaryQuery();
            request.FromDate = _startDate
                .locale('en')
                .format('YYYY-MM-DD 12:00:00');
            request.ToDate = _endDate
                .locale('en')
                .format('YYYY-MM-DD 11:59:59');
            await sendCommand(request);

            const requestBetFail = new CMDPsBetLogFailSummaryQuery();
            requestBetFail.FromDate = _startDate
                .locale('en')
                .format('YYYY-MM-DD 12:00:00');
            requestBetFail.ToDate = _endDate
                .locale('en')
                .format('YYYY-MM-DD 11:59:59');
            await sendCommand(requestBetFail);

            timerRef.current = setTimeout(() => {
                setIsRequest(false);
            }, 5000);
        } else {
            console.warn('app::report::betLog', 'please select date');
        }
    };
    useEffect(() => {
        console.log(isRequest);
        setIsRequest(false);
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
    }, [summaries]);

    useEffect(() => {
        setExtraCloseHandler(() => () => {});
        return () => {
            batch(() => {
                dispatch(betRecordSliceActions.reset());
                dispatch(betSummarySliceActions.reset());
                dispatch(betFailSummarySliceActions.reset());
            });
        };
    }, []);
    const onClose = () => {
        playButtonAudio();
        setIsOpen(false);
    };

    const [page, setPage] = useState(BetRecordTabPage.SUCCESSFUL_BETS_PAGE);

    return (
        <>
            <DateRangePicker
                start={start}
                end={end}
                expanded={expanded}
                setStart={setStart}
                setEnd={setEnd}
                setExpanded={setExpanded}
                showPreset={true}
                handleSubmit={handleSubmit}
                playButtonAudio={playButtonAudio}
            />
            <Grid container item direction={'column'}>
                {isAutoConfirmEnabled && (
                    <Grid item container justifyContent={'center'}>
                        <BetRecordTabs page={page} setPage={setPage} />
                    </Grid>
                )}
                <Box overflow={'auto'}>
                    <BetRecordReport
                        onClose={onClose}
                        playButtonAudio={playButtonAudio}
                        startDate={startDate}
                        endDate={endDate}
                        isFailed={page == BetRecordTabPage.FAILED_BETS_PAGE}
                    />
                </Box>
            </Grid>
            {isRequest && <div className="record-loading"></div>}
        </>
    );
};
